import { TextMsg, QuickReply, Button, Carousel, Card, Checkin, Image } from '../../components/chatElements/chatClasses';

const setMessegPosition = (key, max) => {
    switch (key) {
        case 0:
            return 'First';
        case (max - 1):
            return 'Last';
        default:
            return 'Medium';
    }
}

const processResponse = (rowData) => {

    const context = rowData.data.context;
    const sessionCode = rowData.data.sessionCode;
    const dataAnswers = rowData.data.answers;

    const messages = [];
    let liveAgent = false;

    dataAnswers.forEach((answer, key) => {

        if (answer.technicalText && answer.technicalText.type === null) return;
        const position = setMessegPosition(key, dataAnswers.length);
        liveAgent = answer.technicalText ? answer.technicalText.liveAgentConversation : false;

        const text = answer.content;

        if (text && text.length && answer.type !== "IMAGE") {
            const newMsg = new TextMsg({ fromUser: false, text: text, position: position });
            messages.push(newMsg);
        } else if (text && text.length && answer.type === "IMAGE") {
            const newMsg = new Image({ image: text, position: position });
            messages.push(newMsg);
        }

        const mergedButtons = [
            ...answer.quickReply,
            ...answer.buttons,
            ...(answer.technicalText && answer.technicalText.buttons ? answer.technicalText.buttons : [])
        ];

        if (mergedButtons.length) {
            const buttonsArray = [];
            mergedButtons.forEach(option => {
                const newBtn = new Button({
                    title: option.name,
                    value: option.value,
                    action: option.action,
                    image: option.image,
                    imageAlt: option.imageAlt,
                    type: 'quick_reply'
                });
                buttonsArray.push(newBtn);
            })
            const newQuickReply = new QuickReply({ buttons: buttonsArray });
            messages.push(newQuickReply);
        }

        if (answer.technicalText && answer.technicalText.carrusel) {
            const items = [];
            const carousel = answer.technicalText.carrusel;
            carousel.forEach(element => {
                const buttonsArray = [];
                if (element.buttons) {
                    element.buttons.forEach(option => {
                        const newBtn = new Button({
                            title: option.name,
                            value: option.value,
                            action: option.action,
                            type: 'quick_reply'
                        });
                        buttonsArray.push(newBtn);
                    });
                }
                const newCard = new Card(
                    {
                        title: element.title,
                        image: element.image,
                        description: element.subTitle,
                        buttons: buttonsArray,
                        position: position
                    }
                );
                items.push(newCard);

            });

            const newCarousel = new Carousel({ items: items, position: position });
            messages.push(newCarousel);
        }

        if (answer.technicalText && answer.technicalText.checkin) {
            const newCheckin = new Checkin({ payload: answer.technicalText.checkin.payload, position: position })
            messages.push(newCheckin);
        }
    });
    return { messages, context, sessionCode, liveAgent };



}

export default processResponse;